export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;
      navigator.serviceWorker.register(swUrl).catch(err => {
        console.error('Service worker registration failed:', err);
      });
    });
  }
}
